// DEV-ONLY: the planned Feed, with made-up people and a script playing over it. See docs/feed-redesign-plan.md
// Open http://localhost:3000/?feedNext  (never active in a production build)
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import BetLike from '../components/BetLike';
import { TeamAvatar } from '../components/pools/poolFx';

const ME = 'CL34RY';
const FRIENDS = ['DI4N3', 'Marc88', 'Chungussifu'];
const AVATARS = { CL34RY: { abbrev: 'MTL', name: 'Montréal' }, Marc88: { abbrev: 'TOR', name: 'Toronto' } };
const ROWS_SHOWN = 3;
const BIG_BET = 500;
const SMALL_WIN = 200;       // under this, a win is one line
const BIG_WIN = 1000;        // from this, a win is the big size. To tune against real payouts
const TOP_ZONE = 120;        // scrolled further than this, new posts wait behind the pill
const GAP_MS = 1500;         // quiet time between two moments
const PACES = { demo: 5000, real: 40000, quiet: 30000 };
const LOOP_BUDGET = 3;       // at most this many flames and live dots loop at once
const KEEP = { hand: 5, closed: 2, results: 1, win: 2, big: 1, line: 4, parlaywin: 1, predict: 1, spin: 1, jackpot: 1 };
const PREDICT_LOGOS = ['VGK', 'FLA', 'WSH', 'BOS'];
const FLAME = 'M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z';
const SPARKS = [0, 1, 2, 3, 4, 5, 6, 7];
const EMBERS = [-12, -5, 3, 9, 14];
const DIGITS = '0123456789'.split('');
const REDUCED = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const JELLY = [{ transform: 'none' }, { transform: 'scale(1.02, 0.97)', offset: 0.38 }, { transform: 'scale(0.995, 1.012)', offset: 0.62 }, { transform: 'none' }];
const ROW_BUMP = [{ transform: 'none' }, { transform: 'scale(1.02)', offset: 0.45 }, { transform: 'none' }];

const THEMES = {
  light: {},
  team: { '--accent': '#AF1E2D', '--accent-rgb': '175, 30, 45' },
  dark: { '--bg-dark': '#1b1d22', '--bg-card': '#121317', '--border': '#30333b', '--text': '#f2f3f5', '--text-muted': '#9aa1ab', '--accent': '#ff5722', '--accent-rgb': '255, 87, 34', '--win': '#22c55e' },
};

let logoTone = 'light';       // the NHL's dark logos on the dark theme, same as App.js does
const logo = (a) => `https://assets.nhle.com/logos/nhl/svg/${a}_${logoTone}.svg`;
const money = (n) => `$${Math.round(+n).toLocaleString('en-CA')}`;
const signed = (n) => `${n < 0 ? '-' : '+'}${money(Math.abs(n))}`;
const plain = (n) => String(n);
const profit = (b) => Math.round(b.stake * (b.odds - 1));
const netOf = (bets) => bets.reduce((sum, b) => sum + (b.status === 'won' ? profit(b) : b.status === 'lost' ? -b.stake : 0), 0);
const toneOf = (n) => (n < 0 ? 'lost' : 'won');
const minsAgo = (m) => Date.now() - m * 60000;

function timeAgo(at) {
  const mins = Math.max(0, Math.floor((Date.now() - at) / 60000));
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min`;
  const hours = Math.floor(mins / 60);
  return hours < 24 ? `${hours} h` : `${Math.floor(hours / 24)} d`;
}
const agoText = (at) => { const t = timeAgo(at); return t === 'just now' ? t : `${t} ago`; };

const GAME_TEAMS = {
  'Seattle vs Calgary': ['SEA', 'CGY'], 'Boston vs Montréal': ['BOS', 'MTL'], 'Toronto vs Ottawa': ['TOR', 'OTT'], 'Edmonton vs Vancouver': ['EDM', 'VAN'],
  'Florida vs Winnipeg': ['FLA', 'WPG'], 'Vegas vs New Jersey': ['VGK', 'NJD'], 'Colorado vs Dallas': ['COL', 'DAL'], 'Tampa Bay vs Carolina': ['TBL', 'CAR'],
};
// game, team, pick, odds. No team means no logo and no watermark: over/unders and F1 look like this for real
const POOL = [
  ['Toronto vs Ottawa', 'TOR', 'Toronto to win', 1.95], ['Edmonton vs Vancouver', 'EDM', 'Edmonton -1.5', 2.75], ['Florida vs Winnipeg', 'WPG', 'Winnipeg +1.5', 3.31],
  ['Colorado vs Dallas', null, 'Over 6.5 goals', 1.9, 'O/U'], ['Vegas vs New Jersey', 'NJD', 'New Jersey to win', 3.72], ['Tampa Bay vs Carolina', 'CAR', 'Carolina to win', 2.2],
  ['Boston vs Montréal', 'BOS', 'Boston +1.5', 1.9], ['F1 · Mexico City Grand Prix', null, 'Verstappen to win', 2.4, 'F1'], ['Seattle vs Calgary', 'CGY', 'Calgary -1.5', 2.85],
  ['Colorado vs Dallas', 'COL', 'Colorado to win', 1.8], ['Toronto vs Ottawa', 'OTT', 'Ottawa +1.5', 1.8], ['Florida vs Winnipeg', 'FLA', 'Florida to win', 1.85],
  ['Tampa Bay vs Carolina', 'TBL', 'Tampa Bay -1.5', 2.6], ['Edmonton vs Vancouver', 'VAN', 'Vancouver to win', 2.45], ['Vegas vs New Jersey', 'VGK', 'Vegas -1.5', 2.6],
];
const STAKES = [60, 120, 40, 200, 75, 300, 150, 500, 90];
const SPINS = [300, 150, 640, 220, 1000];
const PREDICTS = [125, 210, 90, 340];
const PARLAYS = [[4, 2300, 250], [3, 880, 100], [6, 5400, 150], [5, 1600, 75]];
const BIGS = [[1500, 3], [800, 2.85], [1000, 2.4], [1200, 3.31]];
const MONTHS = ['September', 'August', 'July'];
const JACKPOTS = [[2500, 1200, 600], [3100, 1500, 750], [1900, 950, 480]];

let nextId = 1;
let poolAt = 0;
let stakeAt = 0;
const makeBet = (row, stake, extra = {}) => ({ id: nextId++, game: row[0], team: row[1], pick: row[2], odds: row[3], mono: row[4], stake, status: 'open', likes: [], ...extra });
const nextBet = (extra) => {
  const row = POOL[poolAt++ % POOL.length];
  const stake = STAKES[stakeAt++ % STAKES.length];
  return makeBet(row, stake, { boosted: !!row[1] && poolAt % 4 === 0, ...extra });
};
const parlayBet = (legs, stake, odds) => ({ id: nextId++, parlay: true, legs, stake, odds, status: 'open', likes: [] });

const CL = [
  ['Boston vs Montréal', 'MTL', 'Montréal to win', 2.15, null, 1000, 'open', ['DI4N3', 'Marc88', 'Chungussifu']], ['Florida vs Winnipeg', 'WPG', 'Winnipeg +1.5', 3.31, null, 1000, 'open', ['DI4N3']],
  ['Vegas vs New Jersey', 'VGK', 'Vegas -1.5', 2.6, null, 1000, 'won', []], ['Toronto vs Ottawa', 'TOR', 'Toronto to win', 1.95, null, 800, 'open', []], ['Toronto vs Ottawa', 'OTT', 'Ottawa +1.5', 1.8, null, 800, 'lost', []],
  ['Edmonton vs Vancouver', 'EDM', 'Edmonton -1.5', 2.75, null, 700, 'open', []], ['Edmonton vs Vancouver', 'VAN', 'Vancouver +1.5', 1.7, null, 700, 'open', []], ['Florida vs Winnipeg', 'FLA', 'Florida to win', 1.85, null, 600, 'won', []],
  ['Vegas vs New Jersey', 'NJD', 'New Jersey to win', 3.72, null, 500, 'open', []], ['Seattle vs Calgary', 'CGY', 'Calgary to win', 1.8, null, 500, 'open', []], ['Seattle vs Calgary', 'SEA', 'Seattle +1.5', 2.6, null, 500, 'open', []],
  ['Boston vs Montréal', 'BOS', 'Boston +1.5', 1.9, null, 400, 'open', []], ['Toronto vs Ottawa', 'TOR', 'Toronto -1.5', 2.9, null, 400, 'open', []],
];
const startPosts = () => {
  const main = CL.map((r) => makeBet(r, r[5], { status: r[6], likes: r[7] }));
  main[1].missed = 'Marc88';
  const hand = (user, mins, bets, extra) => ({ id: nextId++, kind: 'hand', user, at: minsAgo(mins), bets, first: true, ...extra });
  const closedBets = [
    makeBet(POOL[9], 400, { status: 'won', likes: ['CL34RY', 'Marc88'] }), makeBet(POOL[12], 150, { status: 'won' }), makeBet(POOL[1], 200, { status: 'won' }), makeBet(POOL[5], 100, { status: 'lost' }),
    makeBet(POOL[10], 150, { status: 'won' }), makeBet(POOL[13], 100, { status: 'lost' }), makeBet(POOL[0], 120, { status: 'won' }),
  ];
  return [
    { id: nextId++, kind: 'boost', first: true },
    hand('DI4N3', 4, [makeBet(['Seattle vs Calgary', 'SEA', 'Seattle +1.5', 2.6], 40, { boosted: true })]),
    hand(ME, 20, main, { anchor: true }),
    { id: nextId++, kind: 'win', big: true, user: 'Chungussifu', at: minsAgo(33), bet: makeBet(['Boston vs Montréal', 'MTL', 'Montréal to win', 3], 1500), likes: ['DI4N3', 'Marc88', ME, 'Sam'], first: true },
    { id: nextId++, kind: 'line', tone: 'won', user: 'Marc88', at: minsAgo(41), text: 'cashed Toronto to win', amount: 120, likes: ['DI4N3'], first: true },
    { id: nextId++, kind: 'line', tone: 'lost', user: 'Chungussifu', at: minsAgo(48), text: 'ate a loss on Boston to win', amount: 500, likes: [ME, 'Marc88'], first: true },
    hand('Marc88', 62, [
      makeBet(POOL[4], 120, { status: 'won', likes: ['Chungussifu'] }), makeBet(POOL[1], 60, { status: 'lost' }), makeBet(POOL[9], 90, { status: 'won' }), makeBet(POOL[5], 75),
    ]),
    { id: nextId++, kind: 'predict', user: 'Marc88', at: minsAgo(70), amount: 125, likes: [ME, 'DI4N3'], first: true },
    hand('Chungussifu', 88, [parlayBet(4, 500, 7.04)]),
    hand('DI4N3', 180, closedBets, { closed: true, closedAt: minsAgo(25) }),
    { id: nextId++, kind: 'spin', user: 'DI4N3', at: minsAgo(190), amount: 300, likes: ['Marc88'], first: true },
    hand(ME, 230, [makeBet(POOL[14], 200, { status: 'won' }), makeBet(POOL[7], 100, { status: 'lost' }), makeBet(POOL[11], 300, { status: 'won', likes: ['DI4N3', 'Chungussifu'] })], { closed: true, results: true, closedAt: minsAgo(220) }),
    { id: nextId++, kind: 'parlaywin', user: 'Chungussifu', at: minsAgo(260), legs: 3, amount: 880, stake: 100, likes: ['DI4N3', ME, 'Marc88'], first: true },
    hand('Marc88', 300, [makeBet(POOL[3], 75)]),
    { id: nextId++, kind: 'jackpot', month: 'September', at: minsAgo(400), first: true, bets: [
      { id: nextId++, user: 'CL34RY', place: '1st', amount: 2500, likes: ['DI4N3', 'Marc88'] }, { id: nextId++, user: 'Marc88', place: '2nd', amount: 1200, likes: [] }, { id: nextId++, user: 'DI4N3', place: '3rd', amount: 600, likes: [ME] },
    ] },
  ];
};
// a dead evening: few bets, nothing live, nothing big
const quietPosts = () => [
  { id: nextId++, kind: 'hand', user: 'DI4N3', at: minsAgo(52), first: true, bets: [makeBet(POOL[0], 60, { missed: 'Marc88' })] },
  { id: nextId++, kind: 'line', tone: 'won', user: 'Marc88', at: minsAgo(140), text: 'cashed Vegas -1.5', amount: 95, likes: [], first: true },
  { id: nextId++, kind: 'hand', user: 'Chungussifu', at: minsAgo(200), first: true, bets: [makeBet(POOL[7], 100)] },
  { id: nextId++, kind: 'predict', user: 'Marc88', at: minsAgo(600), amount: 90, likes: ['DI4N3'], first: true },
];
const startMissed = (posts) => {
  const by = (fn) => posts.find(fn)?.id;
  return [
    { id: 'm1', postId: by((p) => p.kind === 'win'), user: 'Chungussifu', text: 'hit Montréal to win', amount: 3000, tone: 'won' },
    { id: 'm2', postId: by((p) => p.kind === 'hand' && p.closed && !p.results), user: 'DI4N3', text: 'went 5-2 on 7 bets', amount: netOf(posts.find((p) => p.kind === 'hand' && p.closed && !p.results).bets), tone: 'won' },
    { id: 'm3', postId: by((p) => p.kind === 'line' && p.tone === 'lost'), user: 'Chungussifu', text: 'ate a loss', amount: 500, tone: 'lost' },
    { id: 'm4', postId: by((p) => p.kind === 'spin'), user: 'DI4N3', text: 'hit The Spin', amount: 300, tone: 'won' },
  ];
};
const startGames = () => ({ 'Seattle vs Calgary': { as: 1, hs: 2 }, 'Boston vs Montréal': { as: 2, hs: 2 } });

const makeAnchor = (user) => {
  const count = 8 + (nextId % 5);
  return { id: nextId++, kind: 'hand', user, at: Date.now(), anchor: true, land: true, bets: Array.from({ length: count }, () => nextBet()) };
};

// what stays on the page: each kind keeps its newest few, so the mix survives however long this runs
const slotOf = (p) => {
  if (p.kind !== 'hand') return p.kind === 'win' && p.big ? 'big' : p.kind;
  if (p.results) return 'results';
  return p.closed ? 'closed' : 'hand';
};
function trim(list) {
  const seen = {};
  return list.filter((p) => {
    const slot = slotOf(p);
    seen[slot] = (seen[slot] || 0) + 1;
    return !KEEP[slot] || seen[slot] <= KEEP[slot] || p.anchor;
  });
}
const atTop = (list, post) => {
  const at = list[0]?.kind === 'boost' ? 1 : 0;
  return [...list.slice(0, at), post, ...list.slice(at)];
};
const mapTarget = (list, id, fn) => list.map((p) => {
  if (p.id === id) return fn(p);
  return p.bets && p.bets.some((b) => b.id === id) ? { ...p, bets: p.bets.map((b) => (b.id === id ? fn(b) : b)) } : p;
});
// React re-inserts posts when one moves up, and that restarts CSS animations: one-shot flags must not stay on
const stripFlags = ({ land, moment, first, entering, ...rest }) => rest;
const sweep = (list) => list.map((p) => ({ ...stripFlags(p), ...(p.bets ? { bets: p.bets.map(stripFlags) } : {}) }));

function onScreen(selector) {
  const el = document.querySelector(selector);
  if (!el) return false;
  const r = el.getBoundingClientRect();
  return r.bottom > 40 && r.top < window.innerHeight - 40;
}
const animateEl = (el, frames, ms) => { if (el && !REDUCED) el.animate(frames, { duration: ms, easing: 'cubic-bezier(0.37, 0, 0.63, 1)' }); };

function Face({ name, size }) {
  const a = AVATARS[name];
  // avatars sit on a white disc in every theme, so they always take the light logo
  return <TeamAvatar team={a ? { ...a, logo: `https://assets.nhle.com/logos/nhl/svg/${a.abbrev}_light.svg` } : null} name={name} size={size} />;
}

// every number on the page: columns of digits that slide, so nothing re-renders per frame
function Roll({ value, format = money, from, delay = 0, slow }) {
  const next = format(value);
  const [text, setText] = useState(from === undefined ? next : next.replace(/\d/g, '0'));
  useEffect(() => {
    const t = setTimeout(() => setText(next), delay || 20);
    return () => clearTimeout(t);
  }, [next, delay]);
  const chars = text.split('');
  return (
    <em className={`fn-roll${slow ? ' slow' : ''}`} aria-label={next}>
      {chars.map((c, i) => {
        const right = chars.length - 1 - i;
        if (!/\d/.test(c)) return <i key={`c${right}`} className="fn-ch">{c}</i>;
        return <i key={`d${right}`} className="fn-col" style={{ transform: `translateY(${-(+c) * 10}%)`, transitionDelay: `${right * (slow ? 120 : 50)}ms` }}>{DIGITS.map((d) => <i key={d}>{d}</i>)}</i>;
      })}
    </em>
  );
}

function Burst() {
  return <span className="bet-like-icon fn-burst" aria-hidden="true">{SPARKS.map((i) => <i key={i} className="bet-like-spark" style={{ '--a': `${i * 45}deg`, '--d': `${i % 2 ? 26 : 38}px` }} />)}</span>;
}

// one amount; when it lands it rolls, can punch once and fires one burst of the flame's sparks
function Amount({ value, size, tone, land, spark, slow, format = signed, delay = 0 }) {
  const [hit, setHit] = useState(false);
  useEffect(() => {
    if (!land || !spark || REDUCED) return undefined;
    const t = setTimeout(() => setHit(true), delay + (slow ? 1300 : 800));
    return () => clearTimeout(t);
  }, [land, spark, slow, delay]);
  return (
    <div className={`fn-amount s${size} ${tone}${hit ? ' punch' : ''}`}>
      <Roll value={value} format={format} from={land ? 0 : undefined} delay={land ? delay + 120 : 0} slow={slow} />
      {hit && <Burst />}
    </div>
  );
}

// a friend's flame lands: their face pops by the flame, sparks fly, the face shrinks into it. BetLike itself stays untouched
function Arrival({ who }) {
  if (!who) return null;
  return (
    <span className="fn-arrive" aria-hidden="true">
      <span className="fn-arrive-flame"><svg viewBox="0 0 24 24" width="20" height="20"><path d={FLAME} /></svg></span>
      <span className="bet-like-icon">
        <u className="bet-like-ring" />
        {SPARKS.map((i) => <i key={i} className="bet-like-spark" style={{ '--a': `${i * 45}deg`, '--d': `${i % 2 ? 20 : 30}px` }} />)}
        {EMBERS.map((x, i) => <i key={x} className="bet-like-ember" style={{ '--x': `${x}px`, animationDelay: `${i * 50}ms` }} />)}
      </span>
      <span className="fn-arrive-face"><Face name={who.name} size={22} /></span>
    </span>
  );
}

const likeProps = (t, act) => ({ liked: t.likes.includes(ME), count: t.likes.length, onToggle: () => act.like(t.id) });

function TeamMark({ team, mono, size = 30 }) {
  const [broken, setBroken] = useState(false);
  if (!team || broken) return <span className="feed-mono" style={{ width: size, height: size }}>{mono || '?'}</span>;
  return <img className="feed-logo" src={logo(team)} alt="" style={{ width: size, height: size }} onError={() => setBroken(true)} />;
}

function Watermark({ team, kind }) {
  if (team) return <span className="feed-watermark team" aria-hidden="true"><img src={logo(team)} alt="" /></span>;
  if (kind === 'predict') return <span className="feed-watermark team predict" aria-hidden="true">{PREDICT_LOGOS.map((a) => <i key={a}><img src={logo(a)} alt="" /></i>)}</span>;
  if (kind === 'spin') return <span className="feed-watermark fn-wm-spin" aria-hidden="true"><img src="/slot/stanley-cup.png" alt="" /></span>;
  if (kind === 'parlay') return <span className="feed-watermark" aria-hidden="true"><img src="/brand/bdb-logo.svg" alt="" /></span>;
  if (kind === 'jackpot') return <span className="feed-watermark fn-wm-cup" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 3h10v2h4v3a4 4 0 0 1-4.2 4A5 5 0 0 1 13 14.9V18h3v3H8v-3h3v-3.1A5 5 0 0 1 7.2 12 4 4 0 0 1 3 8V5h4zm0 4H5v1a2 2 0 0 0 2 2zm10 0v3a2 2 0 0 0 2-2V7z" /></svg></span>;
  return null;
}

function Top({ user, at, children, time }) {
  return (
    <div className="feed-top">
      <Face name={user} size={40} />
      <div className="feed-top-text">
        <p><b>{user}</b> {children}</p>
        <time>{time || timeAgo(at)}</time>
      </div>
    </div>
  );
}

function WhoLit({ likes }) {
  const names = [...new Set(likes)];
  if (names.length < 2) return null;
  const shown = names.slice(0, 2).map((n) => (n === ME ? 'you' : n)).join(', ');
  return (
    <div className="fn-lit">
      <span className="fn-lit-faces">{names.slice(0, 3).map((n) => <Face key={n} name={n} size={18} />)}</span>
      <span>{shown}{names.length > 2 ? ` + ${names.length - 2}` : ''}</span>
    </div>
  );
}

function RowMoney({ bet }) {
  const flip = bet.moment === 'flip';
  if (bet.status === 'won') {
    return <div className={`feed-row-money${flip ? ' fn-flip' : ''}`} key="won"><b className="fn-won"><Roll value={profit(bet)} format={signed} from={flip ? 0 : undefined} delay={flip ? 150 : 0} /></b><span>@ {bet.odds.toFixed(2)}</span></div>;
  }
  if (bet.status === 'lost') {
    return <div className="feed-row-money" key="lost"><b className="fn-struck">{money(bet.stake)}<u className={flip ? 'draw' : undefined} /></b><span>lost</span></div>;
  }
  return <div className="feed-row-money" key="open"><b>{money(bet.stake)}</b><span>{bet.boosted && <img className="fn-patch" src="/brand/bdb-patch-icon.svg" alt="Boosted" />}@ {bet.odds.toFixed(2)}</span></div>;
}

function LiveLine({ bet, game }) {
  const [away, home] = GAME_TEAMS[bet.game];
  const total = game.as + game.hs;
  const period = total < 2 ? '1st' : total < 4 ? '2nd' : '3rd';
  return <span className="fn-live"><i className="fn-dot" />{period} · {away}&nbsp;<Roll value={game.as} format={plain} />&nbsp;-&nbsp;<Roll value={game.hs} format={plain} />&nbsp;{home}</span>;
}

function BetRow({ bet, game, act, n, enter }) {
  const fresh = bet.moment === 'new';
  return (
    <BetLike className={`feed-row fn-press${fresh ? ' fn-row-new' : ''}${enter ? ' fn-row-in' : ''}`} style={{ '--i': n }} {...likeProps(bet, act)}>
      {bet.parlay ? <span className="feed-mono">{bet.legs}×</span> : <TeamMark team={bet.team} mono={bet.mono} />}
      <div className="feed-row-main" data-like={bet.id}>
        <b>{bet.parlay ? `${bet.legs}-leg parlay` : bet.pick}</b>
        {game && bet.status === 'open' ? <LiveLine bet={bet} game={game} /> : <span>{bet.parlay ? 'Picks hidden' : bet.game}</span>}
      </div>
      <RowMoney bet={bet} />
      <Arrival key={bet.arrive?.n} who={bet.arrive} />
    </BetLike>
  );
}

// the post the owner already likes
function HandPost({ post, games, act, lead }) {
  const { bets, closed, results } = post;
  const best = (b) => (b.status === 'won' ? profit(b) : b.status === 'lost' ? -b.stake : 0);
  const rows = closed ? [...bets].sort((a, b) => best(b) - best(a)) : bets;
  const total = bets.reduce((sum, b) => sum + b.stake, 0);
  const shown = post.open ? rows : rows.slice(0, ROWS_SHOWN);
  const won = bets.filter((b) => b.status === 'won').length;
  const lost = bets.filter((b) => b.status === 'lost').length;
  const net = netOf(bets);
  const single = bets.length === 1;
  const hidden = bets.length - ROWS_SHOWN;
  const news = post.hiddenNews;

  let sentence;
  if (results) sentence = <>went <b>{won}-{lost}</b> for <b className={toneOf(net) === 'won' ? 'fn-won' : 'fn-lost'}>{signed(net)}</b></>;
  else if (closed) sentence = <>went <b>{won}-{lost}</b> on <b>{bets.length} bets</b></>;
  else if (single && bets[0].parlay) sentence = <>placed a <b>{bets[0].legs}-leg parlay</b> for <b>{money(total)}</b></>;
  else if (single) sentence = <>bet <b>{money(total)}</b></>;
  else sentence = <>placed <b><Roll value={bets.length} format={plain} /> bets</b> for <b><Roll value={total} /></b></>;

  return (
    <div className={`feed-post fn-post fn-hand${post.land && !closed ? ' fn-land' : ''}${post.land && closed ? ' fn-jelly' : ''}`}>
      <div className="fn-art"><Watermark team={lead} /></div>
      <Top user={post.user} at={post.at} time={closed && !results ? `placed ${agoText(post.at)}, closed ${agoText(post.closedAt)}` : null}>
        {sentence}
        {!closed && total >= BIG_BET && <> <span className="feed-big-mark fn-mark">BIG BET</span></>}
      </Top>
      {closed && !results && <div className="fn-net"><Amount value={net} size={32} tone={toneOf(net)} land={post.land} delay={450} /></div>}
      <div className="feed-rows">
        {shown.map((b, i) => <BetRow key={b.id} bet={b} game={games[b.game]} act={act} n={i - ROWS_SHOWN} enter={post.entering && i >= ROWS_SHOWN} />)}
      </div>
      <WhoLit likes={bets.flatMap((b) => b.likes)} />
      {hidden > 0 && (
        <button type="button" className="feed-more" onClick={() => act.toggle(post.id)}>
          {post.open ? 'Show less' : `Show ${hidden} more${news ? `, ${news.won ? `${news.won} just won` : `${news.lost} just lost`}` : ''}`}
        </button>
      )}
    </div>
  );
}

// wins, Predict, Spin, a parlay that hit: same frame, only the size and the watermark change
function AmountPost({ post, act }) {
  let sentence; let detail = null; let wm = null; let value = post.amount; let size = 32; let slow = false; let team = null;
  if (post.kind === 'win') {
    const { bet } = post;
    value = profit(bet);
    size = post.big ? 44 : 32;
    team = bet.team;
    sentence = post.big ? <>hit big</> : <>won</>;
    detail = <>{bet.pick}<span>{money(bet.stake)} @ {bet.odds.toFixed(2)}</span></>;
  } else if (post.kind === 'parlaywin') {
    sentence = <>hit a <b>{post.legs}-leg parlay</b></>;
    detail = <>Picks hidden<span>{money(post.stake)} in</span></>;
    wm = 'parlay';
  } else if (post.kind === 'predict') {
    sentence = <>cashed <b>Predict the Night</b></>;
    wm = 'predict';
  } else {
    sentence = <>hit <b>The Spin</b></>;
    wm = 'spin';
    slow = true;
  }
  return (
    <div className={`feed-post fn-post${post.big ? ' fn-big' : ''}${post.land ? ' fn-land' : ''}`}>
      <div className="fn-art"><Watermark team={team} kind={wm} /></div>
      <BetLike className="fn-solo" {...likeProps(post, act)}>
        <div data-like={post.id}><Top user={post.user} at={post.at}>{sentence}</Top></div>
        <Amount value={value} size={size} tone="won" land={post.land} spark={post.big} slow={slow} />
        {detail && <p className="fn-detail">{detail}</p>}
        <Arrival key={post.arrive?.n} who={post.arrive} />
      </BetLike>
      <WhoLit likes={post.likes} />
    </div>
  );
}

function JackpotPost({ post, act }) {
  return (
    <div className={`feed-post fn-post fn-jackpot${post.land ? ' fn-land' : ''}`}>
      <div className="fn-art"><Watermark kind="jackpot" /></div>
      <div className="fn-jack-top"><b>{post.month} jackpot</b><time>{timeAgo(post.at)}</time></div>
      <div className="feed-rows">
        {post.bets.map((w, i) => (
          <BetLike key={w.id} className={`feed-row fn-place fn-press${post.land ? ' fn-rise' : ''}`} style={{ '--i': post.bets.length - 1 - i }} {...likeProps(w, act)}>
            <Face name={w.user} size={30} />
            <div className="feed-row-main" data-like={w.id}><b>{w.user}</b><span>{w.place} place</span></div>
            <Amount value={w.amount} size={i === 0 ? 32 : 17} tone="gold" land={post.land} spark={i === 0} format={money} delay={(post.bets.length - 1 - i) * 180 + 300} />
            <Arrival key={w.arrive?.n} who={w.arrive} />
          </BetLike>
        ))}
      </div>
    </div>
  );
}

// small results never stack up as loose lines: side by side they share one post
function LinesPost({ lines, act }) {
  const [open, setOpen] = useState(false);
  const extra = lines.length - ROWS_SHOWN;
  const shown = open ? lines : lines.slice(0, ROWS_SHOWN);
  return (
    <div className="feed-post fn-post fn-lines">
      {shown.map((l) => (
        <BetLike key={l.id} className={`fn-line fn-press${l.land ? ' fn-land' : ''}`} {...likeProps(l, act)}>
          <Face name={l.user} size={28} />
          <p data-like={l.id}><b>{l.user}</b> {l.text} <time>{timeAgo(l.at)}</time></p>
          <b className={`fn-line-amt ${l.tone}`}>{l.tone === 'lost' ? '-' : '+'}{money(l.amount)}</b>
          <Arrival key={l.arrive?.n} who={l.arrive} />
        </BetLike>
      ))}
      {extra > 0 && <button type="button" className="feed-more" onClick={() => setOpen((o) => !o)}>{open ? 'Show less' : `and ${extra} more small result${extra > 1 ? 's' : ''}`}</button>}
    </div>
  );
}

export default function FeedNext() {
  const [posts, setPosts] = useState(startPosts);
  const [games, setGames] = useState(startGames);
  const [missed, setMissed] = useState(() => []);
  const [heldN, setHeldN] = useState(0);
  const [tray, setTray] = useState(false);
  const [panel, setPanel] = useState(false);
  const [pace, setPace] = useState('demo');
  const [theme, setTheme] = useState('light');
  logoTone = theme === 'dark' ? 'dark' : 'light';

  const postsNow = useRef(posts);
  postsNow.current = posts;
  const gamesNow = useRef(games);
  gamesNow.current = games;
  const held = useRef([]);
  const claimed = useRef(new Set());
  const leads = useRef(new Map());
  const timers = useRef(new Set());
  const engine = useRef(null);
  const director = useRef({ queue: [], busy: false });
  const counters = useRef({ flame: 0, bets: 0, users: 0, spin: 0, predict: 0, parlay: 0, big: 0, jackpot: 0, line: 0, step: 0 });
  const replays = useRef({ at: 0, n: 0 });
  const listRef = useRef(null);
  const tops = useRef(new Map());
  const loops = useRef(null);

  const later = (fn, ms) => { const t = setTimeout(() => { timers.current.delete(t); fn(); }, ms); timers.current.add(t); };
  const commit = (fn) => setPosts((list) => trim(fn(list)));
  const sweepSoon = () => later(() => setPosts(sweep), 1800);
  // anything that would move posts waits while you're reading further down
  const structural = (fn) => {
    if (window.scrollY > TOP_ZONE) { held.current.push(fn); setHeldN(held.current.length); return; }
    commit(fn);
    sweepSoon();
  };
  const structuralIf = (hold, fn) => {
    if (hold) { structural(fn); return; }
    commit(fn);
    sweepSoon();
  };
  const flush = () => {
    if (!held.current.length) return;
    const waiting = held.current;
    held.current = [];
    setHeldN(0);
    commit((list) => waiting.reduce((acc, fn) => fn(acc), list));
    sweepSoon();
  };
  const addMissed = (m) => setMissed((list) => [{ id: `x${nextId++}`, ...m }, ...list].slice(0, 6));
  const handVisible = (id) => onScreen(`[data-post="${id}"]`);
  // a hand whose ending is waiting behind the pill is spoken for: nothing may end it twice
  const hands = () => postsNow.current.filter((p) => p.kind === 'hand' && !p.closed && !claimed.current.has(p.id));
  const groupRows = () => hands().filter((h) => h.bets.length > 1).flatMap((h) => h.bets.filter((b) => b.status === 'open').map((b) => ({ hand: h, bet: b })));

  const flameArrive = (id, name, loud = true) => {
    const n = nextId++;
    commit((list) => mapTarget(list, id, (t) => ({ ...t, likes: t.likes.includes(name) ? t.likes : [...t.likes, name], missed: null, arrive: loud ? { name, n } : t.arrive })));
    if (loud) later(() => setPosts((list) => mapTarget(list, id, (t) => (t.arrive?.n === n ? { ...t, arrive: null } : t))), 1900);
  };

  const closeDone = () => {
    hands().filter((h) => h.bets.length > 1 && h.bets.every((b) => b.status !== 'open')).forEach((h) => closeHand(h.id));
  };
  const closeHand = (id) => {
    const start = postsNow.current.find((p) => p.id === id);
    if (!start || start.closed || claimed.current.has(id)) return;
    claimed.current.add(id);
    leads.current.delete(id);      // closed, the watermark becomes the best result
    const c = counters.current;
    const fresh = start.anchor ? makeAnchor(FRIENDS[c.users++ % FRIENDS.length]) : null;
    const settled = Object.fromEntries(start.bets.map((b, i) => [b.id, b.status === 'open' ? (i % 3 === 2 ? 'lost' : 'won') : b.status]));
    structural((list) => {
      const h = list.find((p) => p.id === id);
      if (!h) return list;
      const { anchor, ...rest } = h;
      const done = { ...rest, closed: true, closedAt: Date.now(), land: true, open: false, hiddenNews: null, bets: h.bets.map((b) => ({ ...b, status: settled[b.id] || b.status })) };
      const next = atTop(list.filter((p) => p.id !== id), done);
      if (!fresh) return next;
      const at = next.indexOf(done) + 1;
      return [...next.slice(0, at), fresh, ...next.slice(at)];
    });
  };

  const soloSettle = (hand, bet, status) => {
    let item = null;
    claimed.current.add(hand.id);
    const base = { id: nextId++, user: hand.user, at: Date.now(), likes: bet.likes, land: true };
    if (bet.parlay) {
      if (status === 'won') item = { ...base, kind: 'parlaywin', legs: bet.legs, stake: bet.stake, amount: profit(bet) };
    } else if (status === 'lost') {
      item = { ...base, kind: 'line', tone: 'lost', text: `ate a loss on ${bet.pick}`, amount: bet.stake };
    } else if (profit(bet) < SMALL_WIN) {
      item = { ...base, kind: 'line', tone: 'won', text: `cashed ${bet.pick}`, amount: profit(bet) };
    } else {
      item = { ...base, kind: 'win', big: profit(bet) >= BIG_WIN, bet };
    }
    // other people's lost parlays are not readable, so that post simply leaves: same as the real data
    structural((list) => { const rest = list.filter((p) => p.id !== hand.id); return item ? atTop(rest, item) : rest; });
  };

  const resolve = (hand, bet, status, loud) => {
    if (hand.bets.length === 1) { soloSettle(hand, bet, status); return; }
    const seen = loud && handVisible(hand.id);
    const rowSeen = loud && onScreen(`[data-like="${bet.id}"]`);
    const buried = !hand.open && hand.bets.indexOf(bet) >= ROWS_SHOWN;
    commit((list) => list.map((p) => {
      if (p.id !== hand.id) return p;
      const news = p.hiddenNews || { won: 0, lost: 0 };
      return { ...p, hiddenNews: buried ? { ...news, [status]: news[status] + 1 } : p.hiddenNews, bets: p.bets.map((b) => (b.id === bet.id ? { ...b, status, moment: seen ? 'flip' : null } : b)) };
    }));
    sweepSoon();
    if (rowSeen) later(() => { const el = document.querySelector(`[data-like="${bet.id}"]`); animateEl(el && el.closest('.feed-row'), ROW_BUMP, 240); }, 30);
    if (!seen) {
      const won = status === 'won';
      addMissed({ postId: hand.id, user: hand.user, text: `${won ? 'cashed' : 'lost on'} ${bet.pick}`, amount: won ? profit(bet) : bet.stake, tone: status });
    }
    later(() => engine.current.closeDone(), 900);
  };

  const goLive = () => {
    if (Object.keys(gamesNow.current).length >= 2) return;
    const row = hands().flatMap((h) => h.bets).find((b) => b.status === 'open' && GAME_TEAMS[b.game] && b.team && !gamesNow.current[b.game]);
    if (row) setGames((all) => ({ ...all, [row.game]: { as: 0, hs: 0 } }));
  };

  const pickVisible = (rows) => rows.find((r) => onScreen(`[data-like="${r.bet.id}"]`)) || rows[0];

  const events = {
    flame: (loud) => {
      const c = counters.current;
      const targets = [];
      postsNow.current.forEach((p) => {
        if (p.kind === 'boost') return;
        if (p.bets) (p.open ? p.bets : p.bets.slice(0, ROWS_SHOWN)).forEach((b) => targets.push(b));
        else targets.push(p);
      });
      const usable = targets.filter((t) => t.likes.length < 4 && !t.arrive);
      const seen = usable.filter((t) => onScreen(`[data-like="${t.id}"]`));
      // scrolled away, an unseen flame waits: it could add a line above you, and iPhones have no scroll anchoring
      const list = seen.length || window.scrollY <= TOP_ZONE ? (seen.length ? seen : usable) : [];
      if (!list.length) return;
      const t = list[c.flame++ % list.length];
      const who = FRIENDS.find((f) => !t.likes.includes(f)) || 'Sam';
      flameArrive(t.id, who, loud && seen.length > 0);
    },
    newBet: () => {
      const c = counters.current;
      const shape = c.bets++ % 3;
      const user = [...FRIENDS, ME][c.users++ % 4];
      const bets = shape === 0 ? [nextBet()] : shape === 1 ? [nextBet(), nextBet()] : [nextBet(), nextBet(), nextBet(), nextBet()];
      const post = { id: nextId++, kind: 'hand', user, at: Date.now(), land: true, bets };
      structural((list) => atTop(list, post));
    },
    win: (loud) => { const r = pickVisible(groupRows().filter((x) => !gamesNow.current[x.bet.game])) || pickVisible(groupRows()); if (r) resolve(r.hand, r.bet, 'won', loud); },
    loss: (loud) => { const r = pickVisible(groupRows().filter((x) => !gamesNow.current[x.bet.game])) || pickVisible(groupRows()); if (r) resolve(r.hand, r.bet, 'lost', loud); },
    buried: (loud) => {
      const rows = groupRows().filter((r) => r.hand.bets.indexOf(r.bet) >= ROWS_SHOWN && !r.hand.open);
      const r = rows.find((x) => handVisible(x.hand.id)) || rows[0];
      if (r) resolve(r.hand, r.bet, 'won', loud);
    },
    goal: () => {
      const keys = Object.keys(gamesNow.current);
      if (!keys.length) { goLive(); return; }
      const rows = hands().flatMap((h) => h.bets.filter((b) => b.status === 'open' && gamesNow.current[b.game]).map((b) => ({ hand: h, bet: b })));
      const key = rows.find((r) => onScreen(`[data-like="${r.bet.id}"]`))?.bet.game || keys[counters.current.step % keys.length];
      const g = gamesNow.current[key];
      if (g.as + g.hs < 6) {
        const side = (g.as + g.hs + key.length) % 2 ? 'as' : 'hs';
        setGames((all) => ({ ...all, [key]: { ...g, [side]: g[side] + 1 } }));
        return;
      }
      // the game ends: its bets settle quietly, and the next game on someone's bet starts
      const [away, home] = GAME_TEAMS[key];
      const winner = g.as > g.hs ? away : home;
      const result = (b) => (b.team === winner || !b.team ? 'won' : 'lost');
      setGames(({ [key]: over, ...rest }) => rest);
      rows.filter((r) => r.bet.game === key && r.hand.bets.length === 1).forEach((r) => soloSettle(r.hand, r.bet, result(r.bet)));
      commit((list) => list.map((p) => (p.kind === 'hand' && !p.closed && p.bets.length > 1 ? { ...p, bets: p.bets.map((b) => (b.game === key && b.status === 'open' ? { ...b, status: result(b), moment: 'flip' } : b)) } : p)));
      sweepSoon();
      later(() => { engine.current.goLive(); engine.current.closeDone(); }, 900);
    },
    addBet: () => {
      const groups = hands().filter((h) => h.bets.length > 1 && h.bets.length < 16 && !h.anchor);
      const h = groups.find((x) => handVisible(x.id)) || groups[0];
      if (!h) { events.newBet(); return; }
      const bet = nextBet({ moment: 'new' });
      structuralIf(!handVisible(h.id), (list) => list.map((p) => (p.id === h.id ? { ...p, bets: [bet, ...p.bets] } : p)));
    },
    close: () => {
      const groups = hands().filter((h) => h.bets.length > 1 && !h.anchor).sort((a, b) => a.bets.filter((x) => x.status === 'open').length - b.bets.filter((x) => x.status === 'open').length);
      const h = groups[0] || hands().find((x) => x.bets.length > 1);
      if (h) closeHand(h.id);
    },
    big: () => {
      const c = counters.current;
      const [stake, odds] = BIGS[c.big++ % BIGS.length];
      const singles = hands().filter((h) => h.bets.length === 1 && !h.bets[0].parlay && h.bets[0].team && !gamesNow.current[h.bets[0].game]);
      const h = singles.find((x) => handVisible(x.id)) || singles[0];
      const bet = h ? { ...h.bets[0], stake, odds } : nextBet({ stake, odds, team: 'EDM', pick: 'Edmonton to win', game: 'Edmonton vs Vancouver', mono: null });
      const user = h ? h.user : FRIENDS[c.users++ % FRIENDS.length];
      if (h) claimed.current.add(h.id);
      const post = { id: nextId++, kind: 'win', big: true, user, at: Date.now(), likes: bet.likes, land: true, bet };
      structural((list) => atTop(h ? list.filter((p) => p.id !== h.id) : list, post));
    },
    spin: () => {
      const c = counters.current;
      const post = { id: nextId++, kind: 'spin', user: [...FRIENDS, ME][c.spin % 4], at: Date.now(), amount: SPINS[c.spin++ % SPINS.length], likes: [], land: true };
      structural((list) => atTop(list, post));
    },
    predict: () => {
      const c = counters.current;
      const post = { id: nextId++, kind: 'predict', user: [ME, 'Chungussifu', 'DI4N3', 'Marc88'][c.predict % 4], at: Date.now(), amount: PREDICTS[c.predict++ % PREDICTS.length], likes: [], land: true };
      structural((list) => atTop(list, post));
    },
    parlay: () => {
      const c = counters.current;
      const pending = hands().find((h) => h.bets.length === 1 && h.bets[0].parlay);
      const [legs, amount, stake] = PARLAYS[c.parlay++ % PARLAYS.length];
      if (pending) {
        const bet = pending.bets[0];
        claimed.current.add(pending.id);
        const post = { id: nextId++, kind: 'parlaywin', user: pending.user, at: Date.now(), legs: bet.legs, stake: bet.stake, amount: profit(bet), likes: bet.likes, land: true };
        structural((list) => atTop(list.filter((p) => p.id !== pending.id), post));
      } else {
        const post = { id: nextId++, kind: 'hand', user: FRIENDS[c.parlay % 3], at: Date.now(), land: true, bets: [parlayBet(legs, stake, (amount + stake) / stake)] };
        structural((list) => atTop(list, post));
      }
    },
    line: () => {
      const c = counters.current;
      const b = nextBet();
      const lost = c.line++ % 2 === 0;
      const post = { id: nextId++, kind: 'line', tone: lost ? 'lost' : 'won', user: FRIENDS[c.line % 3], at: Date.now(), text: lost ? `ate a loss on ${b.pick}` : `cashed ${b.pick}`, amount: lost ? b.stake : Math.min(profit(b), SMALL_WIN - 5), likes: [], land: true };
      structural((list) => atTop(list, post));
    },
    results: () => {
      const c = counters.current;
      const post = { id: nextId++, kind: 'hand', user: FRIENDS[c.users++ % 3], at: Date.now(), closed: true, results: true, closedAt: Date.now(), land: true, bets: [nextBet({ status: 'won' }), nextBet({ status: 'lost' }), nextBet({ status: 'won' })] };
      structural((list) => atTop(list, post));
    },
    jackpot: () => {
      const c = counters.current;
      const month = MONTHS[c.jackpot % MONTHS.length];
      const amounts = JACKPOTS[c.jackpot++ % JACKPOTS.length];
      const names = [...FRIENDS, ME].slice(c.jackpot % 2);
      const post = { id: nextId++, kind: 'jackpot', month, at: Date.now(), land: true, bets: amounts.map((amount, i) => ({ id: nextId++, user: names[i], place: ['1st', '2nd', '3rd'][i], amount, likes: [] })) };
      structural((list) => atTop(list, post));
    },
  };
  const HOLD = { flame: 300, jackpot: 1900, big: 1300, close: 1100, spin: 1400 };
  const WEIGHT = { jackpot: 6, big: 5, close: 4, win: 3, loss: 3, buried: 3, spin: 3, predict: 3, parlay: 3, goal: 2, newBet: 2, addBet: 2, results: 2, line: 2, flame: 1 };

  // one moment at a time, with quiet in between. If too many wait, the smallest one just updates with no show
  const runNext = () => {
    const d = director.current;
    if (d.busy || !d.queue.length) return;
    d.busy = true;
    const m = d.queue.shift();
    events[m.name](true);
    later(() => { d.busy = false; engine.current.runNext(); }, (HOLD[m.name] || 600) + GAP_MS);
  };
  const direct = (name) => {
    const d = director.current;
    d.queue.push({ name });
    d.queue.sort((a, b) => WEIGHT[b.name] - WEIGHT[a.name]);
    if (d.queue.length > 2) events[d.queue.pop().name](false);
    runNext();
  };

  const like = (id) => setPosts((list) => mapTarget(list, id, (t) => ({ ...t, likes: t.likes.includes(ME) ? t.likes.filter((n) => n !== ME) : [...t.likes, ME] })));
  const toggle = (id) => { setPosts((list) => list.map((p) => (p.id === id ? { ...p, open: !p.open, entering: !p.open, hiddenNews: null } : p))); sweepSoon(); };
  const act = { like, toggle };

  // flames you missed play as they come on screen: at most 3 at a time, once each
  const seen = (id) => {
    const post = postsNow.current.find((p) => String(p.id) === id);
    if (!post) return;
    const targets = post.bets ? post.bets.slice(0, ROWS_SHOWN) : [post];
    targets.filter((t) => t.missed).forEach((t) => {
      const r = replays.current;
      if (Date.now() - r.at > 2000) { r.at = Date.now(); r.n = 0; }
      const n = r.n++;
      const who = t.missed;
      setPosts((list) => mapTarget(list, t.id, (x) => ({ ...x, missed: null })));
      if (n < 3) later(() => engine.current.flameArrive(t.id, who, true), 700 + n * 180);
      else engine.current.flameArrive(t.id, who, false);
    });
  };

  engine.current = { direct, runNext, seen, flameArrive, flush, closeDone, goLive, later };

  const reseed = (mode) => {
    const fresh = mode === 'quiet' ? quietPosts() : startPosts();
    director.current.queue = [];
    held.current = [];
    claimed.current.clear();
    leads.current.clear();
    setHeldN(0);
    setTray(false);
    setPosts(fresh);
    setGames(mode === 'quiet' ? {} : startGames());
    setMissed(mode === 'quiet' ? [] : startMissed(fresh));
    later(() => setPosts(sweep), 900);
  };
  const choosePace = (next) => {
    if ((next === 'quiet') !== (pace === 'quiet')) reseed(next);
    setPace(next);
  };

  useEffect(() => {
    setMissed((list) => (list.length ? list : startMissed(postsNow.current)));
    const t = setTimeout(() => setPosts(sweep), 900);   // the page-load stagger is over
    return () => clearTimeout(t);
  }, []);

  // the script: only what the next step needs, paused while the tab is hidden
  useEffect(() => {
    const SCRIPT = ['flame', 'newBet', 'win', 'goal', 'addBet', 'loss', 'spin', 'big', 'close', 'jackpot', 'predict', 'parlay', 'line', 'flame', 'buried', 'newBet', 'results', 'goal', 'flame'];
    let t;
    const tick = () => {
      if (!document.hidden) {
        const c = counters.current;
        engine.current.direct(pace === 'quiet' ? 'flame' : SCRIPT[c.step++ % SCRIPT.length]);
      }
      t = setTimeout(tick, PACES[pace]);
    };
    t = setTimeout(tick, pace === 'demo' ? 3000 : PACES[pace]);
    return () => clearTimeout(t);
  }, [pace]);

  useEffect(() => {
    const all = timers.current;
    return () => { all.forEach(clearTimeout); all.clear(); };
  }, []);

  // new posts held back land as soon as you're back at the top
  useEffect(() => {
    const onScroll = () => { if (window.scrollY <= TOP_ZONE) engine.current.flush(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // one observer: what's off screen never loops, and only a few things on screen do
  useEffect(() => {
    const visible = new Set();
    const budget = () => {
      document.querySelectorAll('[data-flick]').forEach((el) => el.removeAttribute('data-flick'));
      const order = [...visible].filter((el) => el.isConnected).sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
      ['.bet-like.hot', '.fn-dot'].forEach((sel) => {
        order.flatMap((el) => [...el.querySelectorAll(sel)]).slice(0, LOOP_BUDGET).forEach((el) => el.setAttribute('data-flick', ''));
      });
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { visible.add(e.target); engine.current.seen(e.target.dataset.post); } else visible.delete(e.target);
      });
      budget();
    }, { threshold: 0.1 });
    loops.current = { io, budget };
    return () => { io.disconnect(); loops.current = null; };
  }, []);
  useEffect(() => {
    if (!loops.current) return;
    document.querySelectorAll('[data-post]').forEach((el) => loops.current.io.observe(el));
    loops.current.budget();
  });

  const view = useMemo(() => {
    const out = [];
    posts.forEach((p) => {
      const last = out[out.length - 1];
      if (p.kind === 'line' && last?.kind === 'lines') last.lines.push(p);
      else if (p.kind === 'line') out.push({ kind: 'lines', lines: [p], first: p.first });
      else out.push(p);
    });
    out.forEach((p) => { if (p.kind === 'lines') p.id = `lines:${p.lines[p.lines.length - 1].id}`; });
    // the watermark is the biggest or best bet, unless the last two posts just showed that logo. Once chosen it stays put
    const recent = [];
    out.forEach((p) => {
      let team = p.kind === 'win' ? p.bet.team : null;
      if (p.kind === 'hand') {
        const score = (b) => (p.closed ? (b.status === 'won' ? profit(b) : b.status === 'lost' ? -b.stake : 0) : b.stake);
        const teams = p.bets.filter((b) => b.team).sort((a, b) => score(b) - score(a)).map((b) => b.team);
        team = leads.current.get(p.id) || teams.find((t) => !recent.includes(t)) || teams[0] || null;
        leads.current.set(p.id, team);
      }
      if (team) { recent.push(team); if (recent.length > 2) recent.shift(); }
    });
    return out;
  }, [posts]);

  // posts glide to their new place with a transform, whatever moved them
  useLayoutEffect(() => {
    const next = new Map();
    const sc = window.scrollY;
    listRef.current.querySelectorAll(':scope > [data-post]').forEach((el) => {
      const id = el.dataset.post;
      const top = el.offsetTop;
      const prev = tops.current.get(id);
      next.set(id, { top, sc });
      if (!prev || REDUCED) return;
      const d = (prev.top - prev.sc) - (top - sc);
      const screenTop = top + listRef.current.getBoundingClientRect().top;
      if (Math.abs(d) < 2 || Math.abs(d) > window.innerHeight * 1.5 || screenTop > window.innerHeight || screenTop + el.offsetHeight < 0) return;
      const far = Math.abs(d) > 200;
      if (far) el.style.zIndex = 2;
      const anim = el.animate([{ transform: `translateY(${d}px)` }, { transform: 'none' }], { duration: far ? 450 : 320, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
      anim.onfinish = () => { el.style.zIndex = ''; };
    });
    tops.current = next;
  }, [view]);

  useEffect(() => {
    const root = document.documentElement;
    const vars = THEMES[theme];
    Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
    return () => Object.keys(vars).forEach((k) => root.style.removeProperty(k));
  }, [theme]);

  const liveRows = hands().flatMap((h) => h.bets.filter((b) => b.status === 'open' && games[b.game]).map((b) => ({ hand: h, bet: b })));
  const goTo = (id) => {
    const el = document.querySelector(`[data-post="${id}"]`);
    if (!el) return;
    el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
    later(() => animateEl(el.firstElementChild, JELLY, 550), 450);
  };
  const postIdOf = (id) => {
    const v = view.find((p) => p.id === id || (p.lines && p.lines.some((l) => l.id === id)));
    return v ? v.id : null;
  };
  const closeTray = () => { setTray(false); setMissed([]); };

  return (
    <div className="fn-shell">
      <style>{CSS}</style>
      <div className="fn-page">
        <div className={`fn-pills${heldN > 0 ? ' mid' : ''}`}>
          {heldN > 0 && <button type="button" className="fn-pill" onClick={() => window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' })}>{heldN} new</button>}
          {heldN === 0 && missed.length >= 2 && !tray && <button type="button" className="fn-pill" onClick={() => setTray(true)}>{missed.length} while you were away</button>}
          {tray && (
            <div className="fn-tray">
              {missed.filter((m) => postIdOf(m.postId)).map((m, i) => (
                <button type="button" key={m.id} className="fn-tray-row" style={{ '--i': i }} onClick={() => { const id = postIdOf(m.postId); closeTray(); if (id) goTo(id); }}>
                  <Face name={m.user} size={26} />
                  <span><b>{m.user}</b> {m.text}</span>
                  <b className={`fn-line-amt ${m.tone}`}>{m.tone === 'lost' ? '-' : '+'}{money(m.amount)}</b>
                </button>
              ))}
              <button type="button" className="feed-more" onClick={closeTray}>Got it</button>
            </div>
          )}
        </div>

        <div className="feed-header">
          <h2>Feed</h2>
          {liveRows.length > 0 && <button type="button" className="feed-live fn-livepill" onClick={() => goTo(liveRows[0].hand.id)}><i />{liveRows.length} live</button>}
        </div>

        <div className="feed-list fn-list" ref={listRef}>
          {view.map((p, i) => (
            <div key={p.id} data-post={p.id} className={`fn-item${p.first ? ' feed-item' : ''}`} style={{ '--i': Math.min(i, 5) }}>
              {p.kind === 'boost' && <p className="feed-boost"><b>Boost Weekend</b> Odds ×2 until Sunday at midnight</p>}
              {p.kind === 'hand' && <HandPost post={p} games={games} act={act} lead={leads.current.get(p.id)} />}
              {['win', 'parlaywin', 'predict', 'spin'].includes(p.kind) && <AmountPost post={p} act={act} />}
              {p.kind === 'jackpot' && <JackpotPost post={p} act={act} />}
              {p.kind === 'lines' && <LinesPost lines={p.lines} act={act} />}
            </div>
          ))}
          <p className="fn-end">That’s the last 60</p>
        </div>
      </div>

      <div className="fn-demo">
        {panel && (
          <div className="fn-demo-box">
            <div className="fn-demo-seg">
              {['demo', 'real', 'quiet'].map((k) => <button type="button" key={k} className={pace === k ? 'on' : ''} onClick={() => choosePace(k)}>{{ demo: 'Demo pace', real: 'Real pace', quiet: 'Quiet night' }[k]}</button>)}
            </div>
            <div className="fn-demo-seg">
              {['light', 'team', 'dark'].map((k) => <button type="button" key={k} className={theme === k ? 'on' : ''} onClick={() => setTheme(k)}>{k}</button>)}
            </div>
            <div className="fn-demo-grid">
              {[['flame', 'Friend’s flame'], ['newBet', 'New post'], ['addBet', 'Bet joins post'], ['win', 'Row wins'], ['loss', 'Row loses'], ['buried', 'Hidden row wins'], ['goal', 'Goal'], ['close', 'Hand closes'], ['big', 'Big win'], ['spin', 'Spin'], ['predict', 'Predict'], ['parlay', 'Parlay'], ['line', 'Small result'], ['results', 'Went 2-1'], ['jackpot', 'Jackpot']].map(([k, label]) => (
                <button type="button" key={k} onClick={() => direct(k)}>{label}</button>
              ))}
            </div>
          </div>
        )}
        <button type="button" className="fn-demo-btn" onClick={() => setPanel((o) => !o)}>{panel ? 'Close' : 'Mockup'}</button>
      </div>
    </div>
  );
}

const CSS = `
.fn-shell { min-height: 100vh; background: var(--fl-surface-2); color: var(--text); font-family: var(--fl-font); }
.fn-page { position: relative; max-width: 672px; margin: 0 auto; padding: 16px 16px 90px; }
.fn-list { position: relative; }
.fn-item { position: relative; min-width: 0; }
.fn-livepill { border: 0; cursor: pointer; font-family: inherit; }
.fn-end { margin: 8px 0 0; color: var(--text-muted); font-size: 12px; text-align: center; }

/* one frame for everything, flat. The art sits behind and is clipped by the card */
.fn-post { padding-bottom: 4px; box-shadow: none; }
.fn-post .feed-top, .fn-post .feed-rows, .fn-post .feed-more, .fn-solo, .fn-net, .fn-lit, .fn-jack-top, .fn-line { position: relative; z-index: 1; }
.fn-art { position: absolute; inset: 0; overflow: hidden; border-radius: inherit; pointer-events: none; }
.fn-post .feed-watermark { animation: none; }
.fn-land .feed-watermark { animation: feed-watermark-in 0.6s var(--fl-ease) backwards; }
.fn-post .feed-watermark.team img { transform: scale(1.3); }
.fn-post .feed-watermark.fn-wm-spin { top: 8px; bottom: 8px; right: 70px; width: 90px; height: auto; transform: none; animation: none; }
.fn-post .feed-watermark.fn-wm-cup { right: 170px; width: 120px; height: 120px; }
.fn-post .feed-watermark.predict i img { transform: scale(1.25); }
.fn-big .feed-watermark { width: 200px; height: 200px; opacity: 0.2; }
/* desktop: the logo sits left of the money column, so numbers are always on clean card */
@media (min-width: 601px) { .fn-hand .feed-watermark { right: 170px; } }
.fn-post .feed-logo { transform: scale(1.3); }
.fn-post .feed-mono { font-size: 10px; }
.fn-won { color: var(--win, #16a34a); }
.fn-lost { color: #dc2626; }

.fn-press { transition: transform 0.14s var(--fl-ease); }
.fn-press:active { transform: scale(0.985); }

/* the digit roller */
.fn-roll { display: inline-flex; align-items: flex-start; height: var(--roll, 18px); overflow: hidden; line-height: var(--roll, 18px); font-style: normal; font-variant-numeric: tabular-nums; vertical-align: bottom; }
.fn-roll i { display: block; font-style: normal; }
.fn-live { --roll: 14px; }
.feed-row-money, .fn-amount.s17 { --roll: 20px; }
.fn-amount.s32 { --roll: 38px; }
.fn-amount.s44 { --roll: 52px; }
.fn-roll .fn-ch { flex: none; }
.fn-col { flex: none; transition: transform 0.4s cubic-bezier(0.2, 0.9, 0.2, 1.05); will-change: transform; }
.fn-roll.slow .fn-col { transition-duration: 0.9s; transition-timing-function: cubic-bezier(0.2, 0.9, 0.25, 1.12); }

.fn-net { display: flex; flex-wrap: wrap; align-items: center; gap: 2px 12px; margin: 6px 0 0 50px; }
.fn-mark { margin-left: 0; }

/* settled rows */
.fn-struck { position: relative; display: inline-block; color: var(--text-muted); }
.fn-struck u { position: absolute; left: -1px; right: -1px; top: 52%; height: 2px; background: #dc2626; transform-origin: 0 50%; }
.fn-struck u.draw { animation: fn-draw 0.24s var(--fl-ease) backwards; }
@keyframes fn-draw { from { transform: scaleX(0); } }
.fn-flip { animation: fn-flip 0.3s var(--fl-ease); transform-origin: 50% 50%; }
@keyframes fn-flip { from { transform: perspective(200px) rotateX(90deg); opacity: 0; } }
.fn-patch { width: 13px; height: 13px; margin-right: 4px; vertical-align: -2px; object-fit: contain; }
.fn-row-new { animation: fn-row-new 0.55s cubic-bezier(0.37, 0, 0.63, 1); transform-origin: 0 0; }
@keyframes fn-row-new { 0% { transform: translateY(-10px) scale(0.98); opacity: 0; } 45% { transform: scale(1.015, 0.97); opacity: 1; } 75% { transform: scale(0.995, 1.01); } 100% { transform: none; } }
.fn-row-in { animation: chat-tray-item 0.34s cubic-bezier(0.3, 0.8, 0.4, 1) backwards; animation-delay: calc(var(--i, 0) * 35ms); }

/* a live row is only a different line of small text */
.fn-live { display: inline-flex !important; align-items: center; color: var(--text) !important; font-weight: 600; line-height: 14px; }
.fn-dot { flex: none; width: 6px; height: 6px; margin-right: 5px; border-radius: 50%; background: #dc2626; }
.fn-dot[data-flick] { animation: feed-live 1.6s ease-in-out infinite; }

/* only a few flames flicker, and only on screen */
.fn-page .bet-like.hot:not([data-flick]) .bet-like-icon:not([data-pop]):not([data-fizz]) svg { animation: none; }

/* who lit it */
.fn-lit { display: flex; align-items: center; gap: 6px; padding: 7px 0 6px; border-top: 1px solid var(--fl-line); color: var(--text-muted); font-size: 12px; }
.fn-lit-faces { display: inline-flex; }
.fn-lit-faces > * + * { margin-left: -4px; }
.fn-lit-faces .pfx-avatar { box-shadow: 0 0 0 1.5px var(--fl-surface); }
.fn-lit-faces .pfx-avatar.logo { box-shadow: inset 0 0 0 1px var(--fl-line), 0 0 0 1.5px var(--fl-surface); }

/* a friend's flame */
.fn-arrive { position: absolute; top: 50%; right: 35px; width: 0; height: 0; z-index: 3; pointer-events: none; }
.fn-arrive .bet-like-icon { position: absolute; left: 0; top: 0; }
.fn-arrive-flame { position: absolute; left: -10px; top: -10px; animation: fn-arrive-flame 1.1s var(--fl-ease) both; transform-origin: 50% 85%; }
.fn-arrive-flame svg { display: block; }
.fn-arrive-flame path { fill: #ff6a13; stroke: #e0360b; stroke-width: 2; stroke-linejoin: round; }
.fn-arrive-face { position: absolute; left: -11px; top: -39px; display: flex; border-radius: 50%; box-shadow: 0 0 0 2px var(--fl-surface); animation: fn-arrive-face 1.8s linear both; }
@keyframes fn-arrive-flame { 0% { transform: scale(0.2) translateY(5px); opacity: 1; } 28% { transform: scale(1.6, 1.8) rotate(-10deg); } 45% { transform: scale(0.92) rotate(5deg); } 60% { transform: none; opacity: 1; } 100% { transform: none; opacity: 0; } }
@keyframes fn-arrive-face {
  0% { transform: scale(0); }
  10% { transform: scale(1.12, 1.05); }
  17% { transform: scale(0.97, 1.03); }
  24% { transform: none; }
  88% { transform: none; opacity: 1; }
  100% { transform: translateY(30px) scale(0.2); opacity: 0; }
}

/* landing */
.fn-land { animation: fn-land 0.55s cubic-bezier(0.37, 0, 0.63, 1) both; transform-origin: 0 0; }
@keyframes fn-land { 0% { transform: translateY(-26px) scale(0.96); opacity: 0; } 45% { transform: scale(1.012, 0.982); opacity: 1; } 75% { transform: scale(0.997, 1.006); } 100% { transform: none; } }
.fn-jelly { animation: fn-jelly 0.55s cubic-bezier(0.37, 0, 0.63, 1) 0.42s; }
@keyframes fn-jelly { 38% { transform: scale(1.012, 0.98); } 62% { transform: scale(0.997, 1.006); } }

/* amounts */
.fn-amount { position: relative; display: inline-block; font-family: var(--fl-display); font-weight: 800; line-height: 1.15; transform-origin: 0 60%; }
.fn-amount.s17 { font-size: 17px; }
.fn-amount.s32 { font-size: 32px; }
.fn-amount.s44 { font-size: 44px; }
.fn-amount.won { color: var(--win, #16a34a); }
.fn-amount.lost { color: #dc2626; }
.fn-amount.gold { color: #d97706; }
.fn-amount.punch { animation: fn-punch 0.2s var(--fl-ease); }
@keyframes fn-punch { 50% { transform: scale(1.08); } }
.fn-burst { position: absolute !important; left: 100%; top: 50%; pointer-events: none; }
.fn-solo { padding: 0 0 8px; }
.fn-solo .feed-top { padding-right: 52px; }
.fn-solo > .fn-amount { display: block; width: fit-content; margin: 4px 0 0 50px; }
.fn-solo > .bet-like { position: absolute; top: -4px; right: 0; width: 58px; margin: 0; padding: 0; justify-content: center; z-index: 2; }
.fn-solo .fn-arrive { top: 12px; right: 35px; }
.fn-detail { margin: 2px 0 0 50px; font-size: 14px; font-weight: 700; }
.fn-detail span { margin-left: 8px; color: var(--text-muted); font-size: 12px; font-weight: 400; }

/* jackpot */
.fn-jack-top { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.fn-jack-top b { font-family: var(--fl-display); font-size: 22px; font-weight: 800; }
.fn-jack-top time { color: var(--text-muted); font-size: 12px; }
.fn-place { grid-template-columns: 30px minmax(0, 1fr) auto 58px; }
.fn-place .fn-amount { justify-self: end; }
.fn-rise { animation: fn-rise 0.5s cubic-bezier(0.37, 0, 0.63, 1) backwards; animation-delay: calc(var(--i) * 180ms); }
@keyframes fn-rise { 0% { transform: translateY(24px); opacity: 0; } 55% { transform: scale(1.02, 0.96); opacity: 1; } 80% { transform: scale(0.995, 1.01); } 100% { transform: none; } }

/* small results share one post */
.fn-lines { padding: 2px 14px; }
.fn-line { display: grid; grid-template-columns: 28px minmax(0, 1fr) auto 58px; align-items: center; gap: 10px; min-height: 46px; padding: 5px 0; }
.fn-line + .fn-line { border-top: 1px solid var(--fl-line); }
.fn-line p { margin: 0; font-size: 13px; line-height: 1.3; overflow-wrap: anywhere; }
.fn-line time { color: var(--text-muted); font-size: 12px; white-space: nowrap; }
.fn-line .bet-like { justify-self: stretch; justify-content: center; margin: 0; padding: 0; }
.fn-line-amt { flex: none; font-family: var(--fl-display); font-size: 17px; font-weight: 800; font-variant-numeric: tabular-nums; }
.fn-line-amt.won { color: var(--win, #16a34a); }
.fn-line-amt.lost { color: #dc2626; }

/* the pill takes no room: nothing moves when it comes or goes */
.fn-pills { position: sticky; top: 8px; z-index: 12; display: flex; justify-content: flex-end; height: 0; }
.fn-pills.mid { justify-content: center; }
.fn-pill { align-self: flex-start; padding: 7px 14px; border: 0; border-radius: 999px; background: var(--text); color: var(--fl-surface); font-family: inherit; font-size: 13px; font-weight: 700; white-space: nowrap; cursor: pointer; animation: fx-pop-next 0.24s cubic-bezier(0.34, 1.56, 0.64, 1); }
@keyframes fx-pop-next { from { transform: scale(0.8); opacity: 0; } }
.fn-tray { align-self: flex-start; width: min(100%, 420px); border-radius: var(--fl-radius-lg); background: var(--fl-surface); box-shadow: 0 8px 24px rgba(16, 24, 40, 0.2), 0 0 0 1px var(--fl-line); overflow: hidden; transform-origin: 50% 0; animation: fn-tray 0.42s cubic-bezier(0.37, 0, 0.63, 1) both; }
@keyframes fn-tray { 0% { transform: translateY(-12px) scale(0.96); opacity: 0; } 55% { transform: scale(1.01, 0.99); opacity: 1; } 100% { transform: none; } }
.fn-tray-row { display: grid; grid-template-columns: 26px minmax(0, 1fr) auto; align-items: center; gap: 10px; width: 100%; padding: 10px 14px; border: 0; border-bottom: 1px solid var(--fl-line); background: none; color: inherit; font: inherit; font-size: 13px; text-align: left; cursor: pointer; animation: chat-tray-item 0.34s cubic-bezier(0.3, 0.8, 0.4, 1) backwards; animation-delay: calc(var(--i, 0) * 35ms + 60ms); }
.fn-tray-row:hover { background: var(--fl-accent-soft); }
.fn-tray .feed-more { border-top: 0; }

/* the mockup's own controls, not part of the design */
.fn-demo { position: fixed; left: 12px; bottom: 12px; z-index: 30; display: flex; flex-direction: column; align-items: flex-start; gap: 8px; max-width: calc(100vw - 24px); }
.fn-demo-btn { padding: 6px 12px; border: 1px dashed var(--text-muted); border-radius: 999px; background: var(--fl-surface); color: var(--text-muted); font-family: inherit; font-size: 12px; font-weight: 700; cursor: pointer; }
.fn-demo-box { width: 330px; max-width: 100%; padding: 10px; border: 1px dashed var(--text-muted); border-radius: var(--fl-radius-lg); background: var(--fl-surface); display: flex; flex-direction: column; gap: 8px; }
.fn-demo-seg, .fn-demo-grid { display: flex; flex-wrap: wrap; gap: 4px; }
.fn-demo-box button { padding: 5px 8px; border: 1px solid var(--fl-line); border-radius: var(--fl-radius-sm); background: none; color: var(--text); font-family: inherit; font-size: 12px; cursor: pointer; text-transform: capitalize; }
.fn-demo-box button.on { background: var(--text); color: var(--fl-surface); }

@media (max-width: 600px) {
  /* phone: no free room beside the money, so the logo bleeds off the card edge and stays behind the flame column only */
  .fn-post .feed-watermark.team:not(.predict), .fn-post .feed-watermark.fn-wm-cup { right: -26px; width: 112px; height: 112px; }
  .fn-big .feed-watermark.team:not(.predict) { right: -30px; width: 150px; height: 150px; }
  /* one low row beside the amount: never behind the sentence, however it wraps */
  .fn-post .feed-watermark.predict { top: auto; bottom: 12px; right: 12px; height: 38px; grid-template-columns: repeat(4, 38px); transform: none; animation: none; }
  .fn-post .feed-watermark.predict i { width: 38px; height: 38px; }
  .fn-post .feed-watermark.fn-wm-spin { right: 44px; }
  /* a narrower flame column gives the matchup line its room */
  .fn-post .feed-row { grid-template-columns: 30px minmax(0, 1fr) 80px 46px; gap: 8px; }
  .fn-post .fn-place { grid-template-columns: 30px minmax(0, 1fr) auto 46px; }
  .fn-line { grid-template-columns: 28px minmax(0, 1fr) auto 46px; gap: 8px; }
  .fn-solo > .bet-like { width: 46px; }
  .fn-solo .feed-top { padding-right: 40px; }
  .fn-arrive, .fn-solo .fn-arrive { right: 29px; }
  .fn-pill { font-size: 12px; }
}
@media (prefers-reduced-motion: reduce) {
  .fn-col { transition: none; }
  .fn-land, .fn-jelly, .fn-rise, .fn-row-new, .fn-row-in, .fn-flip, .fn-struck u.draw, .fn-amount.punch, .fn-pill, .fn-tray, .fn-tray-row, .fn-arrive-flame, .fn-arrive-face, .fn-dot[data-flick] { animation: none; }
  .fn-arrive-flame { opacity: 0; }
}
`;
